module.exports = __webpack_public_path__ + "img/buying.fd97fd6e.jpg";